import { createUiKit } from '@barbanet/ui-kit'

import '@barbanet/ui-kit/styles'

export default createUiKit({
	theme: {
		default: {
			name: 'driver'
		}
	},
	defaults: {
		BInput: {
			variant: 'outline',
			clearable: true
		},
		BDateTimePicker: {
			variant: 'outline',
			clearable: true
		},
		BDropdown: {
			variant: 'outline'
		},
		BSnackbar: {
			position: 'top-center',
			closable: true
		},
		BModal: {
			maxWidth: 280
		},
		BFileInput: {
			variant: 'outline',
			clearable: true
		}
	}
})
